import { createContext, useContext, type ReactNode } from 'react';
import { useMe, useLogout } from '@/api/hooks/useAuth';

interface User {
  id: string;
  email: string;
  email_verified: boolean;
}

interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  isLoading: true,
  isAuthenticated: false,
  logout: () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const { data, isLoading } = useMe();
  const logoutMut = useLogout();

  return (
    <AuthContext.Provider
      value={{
        user: data?.user ?? null,
        isLoading,
        isAuthenticated: !!data?.user,
        logout: () => logoutMut.mutate(),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
